import { Injectable } from '@angular/core';
import { ICustomerContext } from '@app/shared/models/context/customer.context.model';
import { ContextBase } from './base/context.base.service';
import { COUNTRY } from '@app/shared/types/enums';

@Injectable({
  providedIn: 'root',
})
export class CustomerContext extends ContextBase<ICustomerContext> {
  constructor() {
    super();
  }

  getRppUserId(): string {
    return this.context?.rppUserId || '';
  }

  getUserId(): string {
    return this.context?.userId || '';
  }

  getCustomerCountry(): COUNTRY | string {
    return this.context?.country || '';
  }
}
